/**
 * @generated SignedSource<<86a1e3b4b29d592ea6f67db51d797835>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EvaluatorKind = "BUILTIN" | "CODE" | "LLM";
export type TimeRange = {
  end?: string | null;
  start?: string | null;
};
export type GlobalDashboardPageQuery$variables = {
  timeRange: TimeRange;
};
export type GlobalDashboardPageQuery$data = {
  readonly evaluators: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isBuiltin: boolean;
        readonly kind: EvaluatorKind;
        readonly name: string;
      };
    }>;
  };
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly ann_citation: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_closed_qa: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_compile: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_consistency: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_contains: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_convquality: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_crosslang: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_cultural: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_determinism: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_domain: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_efficiency: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_factcheck: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_failure: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_fewshot: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_format: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_helpfulness: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_instruction: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_latency: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_moderation: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_perplexity: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_prompt: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_reasoning: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_refusal: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_regex: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_reqfields: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_responsetime: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_retrieval: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_role: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_satisfaction: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_schema: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_security: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_sql: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_stability: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_structure: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_syntax: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_system: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_tempsens: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_testcase: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_token: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_toolinvoke: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_toolusage: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_trace: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_translation: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_uptodate: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly costSummary: {
          readonly total: {
            readonly cost: number | null;
            readonly tokens: number | null;
          };
        };
        readonly gradientEndColor: string;
        readonly gradientStartColor: string;
        readonly id: string;
        readonly latencyMsP50: number | null;
        readonly name: string;
        readonly piiAnnotation: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly spanAnnotationAgentSummaries: ReadonlyArray<{
          readonly meanScore: number;
          readonly name: string;
          readonly numScores: number;
        }>;
        readonly topModelsByCost: ReadonlyArray<{
          readonly costSummary: {
            readonly total: {
              readonly cost: number | null;
              readonly tokens: number | null;
            };
          };
          readonly id: string;
          readonly name: string;
        }>;
        readonly traceAnnotationSummaries: ReadonlyArray<{
          readonly count: number;
          readonly meanScore: number | null;
          readonly name: string;
        }>;
        readonly traceAnnotationSummary: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly traceAnnotationsNames: ReadonlyArray<string>;
        readonly traceCount: number;
      };
    }>;
  };
};
export type GlobalDashboardPageQuery = {
  response: GlobalDashboardPageQuery$data;
  variables: GlobalDashboardPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timeRange"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "timeRange",
  "variableName": "timeRange"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": (v4/*: any*/),
  "concreteType": "SpanCostSummary",
  "kind": "LinkedField",
  "name": "costSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CostBreakdown",
      "kind": "LinkedField",
      "name": "total",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tokens",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meanScore",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "ProjectConnection",
  "kind": "LinkedField",
  "name": "projects",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Project",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gradientStartColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gradientEndColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v4/*: any*/),
              "kind": "ScalarField",
              "name": "traceCount",
              "storageKey": null
            },
            (v5/*: any*/),
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": "GenerativeModel",
              "kind": "LinkedField",
              "name": "topModelsByCost",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": "latencyMsP50",
              "args": [
                {
                  "kind": "Literal",
                  "name": "probability",
                  "value": 0.5
                },
                (v3/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "latencyMsQuantile",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "traceAnnotationsNames",
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "traceAnnotationSummaries",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": "SpanAnnotationAgentSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationAgentSummaries",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "numScores",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": "traceAnnotationSummary",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "General_Correctness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "piiAnnotation",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "pii_detection"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": "ann_instruction",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Instruction_Compliance"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_prompt",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Prompt_Adherence"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_token",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Token_Breakdown"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_trace",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Trace_Completeness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_failure",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Failure_Rates"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_latency",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Span_Latency"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_role",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Role_Consistency"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_system",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "System_Prompt_Leakage"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_fewshot",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Few_Shot_Effectiveness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_translation",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Translation_Accuracy"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_crosslang",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "CrossLanguage_Consistency"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_cultural",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Cultural_Appropriateness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_format",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Format_Compliance"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_schema",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Schema_Validation"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_reqfields",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Required_Fields_Present"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_structure",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Structure_Correctness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_regex",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Regex_Match"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_syntax",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Syntax_Correctness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_compile",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Compilation_Success"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_efficiency",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Efficiency_of_Code"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_testcase",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Test_Case_Pass_Rate"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_security",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Security_Vulnerabilities"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_helpfulness",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Helpfulness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_satisfaction",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Satisfaction_Score"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_responsetime",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Response_Time_Perception"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_convquality",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Conversational_Quality"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_domain",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Domain_Accuracy"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_uptodate",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Up_To_Date_Knowledge"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_factcheck",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Fact_Checking_Accuracy"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_citation",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Citation_Correctness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_moderation",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Moderation"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_closed_qa",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Model-Graded Closed QA"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_retrieval",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Retrieval_vs_Generation"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_consistency",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Same_Input_Same_Output"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_stability",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Stability_Across_Runs"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_tempsens",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Temperature_Sensitivity"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_determinism",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Determinism"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_sql",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Sql_Evaluation"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_toolusage",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Tool_Usage_Correctness"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_toolinvoke",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Tool_Invocation"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_reasoning",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Multi_Step_Reasoning"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_contains",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Contains_Substring"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_refusal",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Is-Refusal"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            },
            {
              "alias": "ann_perplexity",
              "args": [
                {
                  "kind": "Literal",
                  "name": "annotationName",
                  "value": "Perplexity"
                },
                (v3/*: any*/)
              ],
              "concreteType": "AnnotationSummary",
              "kind": "LinkedField",
              "name": "spanAnnotationSummary",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projects(first:100)"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBuiltin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalDashboardPageQuery",
    "selections": [
      (v9/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "EvaluatorConnection",
        "kind": "LinkedField",
        "name": "evaluators",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EvaluatorEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "evaluators(first:200)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalDashboardPageQuery",
    "selections": [
      (v9/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "EvaluatorConnection",
        "kind": "LinkedField",
        "name": "evaluators",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EvaluatorEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "evaluators(first:200)"
      }
    ]
  },
  "params": {
    "cacheID": "2e70b4dc7202dc8d08ab9f2db809285b",
    "id": null,
    "metadata": {},
    "name": "GlobalDashboardPageQuery",
    "operationKind": "query",
    "text": "query GlobalDashboardPageQuery(\n  $timeRange: TimeRange!\n) {\n  projects(first: 100) {\n    edges {\n      node {\n        id\n        name\n        gradientStartColor\n        gradientEndColor\n        traceCount(timeRange: $timeRange)\n        costSummary(timeRange: $timeRange) {\n          total {\n            cost\n            tokens\n          }\n        }\n        topModelsByCost(timeRange: $timeRange) {\n          id\n          name\n          costSummary(timeRange: $timeRange) {\n            total {\n              cost\n              tokens\n            }\n          }\n        }\n        latencyMsP50: latencyMsQuantile(probability: 0.5, timeRange: $timeRange)\n        traceAnnotationsNames\n        traceAnnotationSummaries(timeRange: $timeRange) {\n          name\n          meanScore\n          count\n        }\n        spanAnnotationAgentSummaries(timeRange: $timeRange) {\n          name\n          meanScore\n          numScores\n        }\n        traceAnnotationSummary: spanAnnotationSummary(annotationName: \"General_Correctness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        piiAnnotation: spanAnnotationSummary(annotationName: \"pii_detection\", timeRange: $timeRange) {\n          count\n          meanScore\n        }\n        ann_instruction: spanAnnotationSummary(annotationName: \"Instruction_Compliance\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_prompt: spanAnnotationSummary(annotationName: \"Prompt_Adherence\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_token: spanAnnotationSummary(annotationName: \"Token_Breakdown\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_trace: spanAnnotationSummary(annotationName: \"Trace_Completeness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_failure: spanAnnotationSummary(annotationName: \"Failure_Rates\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_latency: spanAnnotationSummary(annotationName: \"Span_Latency\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_role: spanAnnotationSummary(annotationName: \"Role_Consistency\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_system: spanAnnotationSummary(annotationName: \"System_Prompt_Leakage\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_fewshot: spanAnnotationSummary(annotationName: \"Few_Shot_Effectiveness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_translation: spanAnnotationSummary(annotationName: \"Translation_Accuracy\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_crosslang: spanAnnotationSummary(annotationName: \"CrossLanguage_Consistency\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_cultural: spanAnnotationSummary(annotationName: \"Cultural_Appropriateness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_format: spanAnnotationSummary(annotationName: \"Format_Compliance\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_schema: spanAnnotationSummary(annotationName: \"Schema_Validation\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_reqfields: spanAnnotationSummary(annotationName: \"Required_Fields_Present\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_structure: spanAnnotationSummary(annotationName: \"Structure_Correctness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_regex: spanAnnotationSummary(annotationName: \"Regex_Match\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_syntax: spanAnnotationSummary(annotationName: \"Syntax_Correctness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_compile: spanAnnotationSummary(annotationName: \"Compilation_Success\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_efficiency: spanAnnotationSummary(annotationName: \"Efficiency_of_Code\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_testcase: spanAnnotationSummary(annotationName: \"Test_Case_Pass_Rate\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_security: spanAnnotationSummary(annotationName: \"Security_Vulnerabilities\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_helpfulness: spanAnnotationSummary(annotationName: \"Helpfulness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_satisfaction: spanAnnotationSummary(annotationName: \"Satisfaction_Score\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_responsetime: spanAnnotationSummary(annotationName: \"Response_Time_Perception\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_convquality: spanAnnotationSummary(annotationName: \"Conversational_Quality\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_domain: spanAnnotationSummary(annotationName: \"Domain_Accuracy\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_uptodate: spanAnnotationSummary(annotationName: \"Up_To_Date_Knowledge\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_factcheck: spanAnnotationSummary(annotationName: \"Fact_Checking_Accuracy\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_citation: spanAnnotationSummary(annotationName: \"Citation_Correctness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_moderation: spanAnnotationSummary(annotationName: \"Moderation\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_closed_qa: spanAnnotationSummary(annotationName: \"Model-Graded Closed QA\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_retrieval: spanAnnotationSummary(annotationName: \"Retrieval_vs_Generation\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_consistency: spanAnnotationSummary(annotationName: \"Same_Input_Same_Output\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_stability: spanAnnotationSummary(annotationName: \"Stability_Across_Runs\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_tempsens: spanAnnotationSummary(annotationName: \"Temperature_Sensitivity\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_determinism: spanAnnotationSummary(annotationName: \"Determinism\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_sql: spanAnnotationSummary(annotationName: \"Sql_Evaluation\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_toolusage: spanAnnotationSummary(annotationName: \"Tool_Usage_Correctness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_toolinvoke: spanAnnotationSummary(annotationName: \"Tool_Invocation\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_reasoning: spanAnnotationSummary(annotationName: \"Multi_Step_Reasoning\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_contains: spanAnnotationSummary(annotationName: \"Contains_Substring\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_refusal: spanAnnotationSummary(annotationName: \"Is-Refusal\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_perplexity: spanAnnotationSummary(annotationName: \"Perplexity\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n      }\n    }\n  }\n  evaluators(first: 200) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        kind\n        isBuiltin\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "abf85f82b1d89680045d3347ab6b4be0";

export default node;
